import type { ReactNode } from 'react';
import './Meter.css';

export interface MeterProps {
  /** 0..max. */
  value: number;
  max?: number;
  /** Where the bar turns from "fine" to a warning or a gate line, in the same unit. */
  target?: number;
  label: string;
  tone?: 'accent' | 'success' | 'warning' | 'danger';
  /** Text shown at the right end, already formatted. */
  display?: string;
}

/** A horizontal bar with an optional target line; used for gates, quota and utilisation. */
export function Meter({
  value,
  max = 100,
  target,
  label,
  tone = 'accent',
  display,
}: MeterProps): ReactNode {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  const targetPct =
    target === undefined ? undefined : Math.max(0, Math.min(100, (target / max) * 100));
  return (
    <div className="pui-meter-wrap">
      <div
        className={`pui-meter pui-meter--${tone}`}
        role="meter"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={max}
        aria-valuenow={value}
      >
        <span className="pui-meter__fill" style={{ width: `${pct}%` }} />
        {targetPct !== undefined ? (
          <span className="pui-meter__target" style={{ left: `${targetPct}%` }} />
        ) : null}
      </div>
      {display ? <span className="pui-meter__display">{display}</span> : null}
    </div>
  );
}
